const NotFoundPage= ()=>{
    return <>not found</>
}

export default NotFoundPage